module.exports = __webpack_public_path__ + "img/Circulo-Logo-Impresion3D-selected.2966db0e.png";